export default __webpack_public_path__ + "static/media/village2_sm.9420bf5b.jpg";